import { ObjectSchema, object, string, date, number } from 'yup';
import { locale } from '../yup-locale';
import * as yup from 'yup';
import { CommunicationProtocol, ProtocolType } from '../../models/communication-protocol';
import { communicationTypes } from '../../models/fu-unit';
yup.setLocale(locale);

export function CommunicationProtocolValidator(): ObjectSchema<CommunicationProtocol> {
    return object({
        id: string().uuid().nonNullable().strict().notRequired(),
        type: number()
            .oneOf([ProtocolType.POLLING, ProtocolType.RECEIVER, ProtocolType.RESPONDER, ProtocolType.TRANSMITER])
            .nonNullable()
            .required(),
        boardType: string().oneOf([communicationTypes.serial, communicationTypes.lan]).nonNullable().required(),
        name: string().nonNullable().strict().required().max(48),
        createdAt: date().notRequired(),
    })
        .required()
        .strict()
        .noUnknown()
        .nonNullable();
}
